var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.7186cc3054e35fe6672212db2bf98a8b.svg#g';
                    var viewUrl = 'sprites.7186cc3054e35fe6672212db2bf98a8b.svg#view-g';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 12 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };